type ErrList =
  | Array<{ message?: string | null; code?: string | null } | null>
  | null
  | undefined;

type TFn = (key: string) => string;

/**
 * Known backend error codes of `blockStudentLmsAccess` /
 * `unblockStudentLmsAccess` → i18n keys. ТЗ 0074 removed `not_a_debtor`: a
 * manual suspension no longer requires a contribution-plan debt.
 */
export const LMS_BLOCK_ERROR_KEYS: Record<string, string> = {
  does_not_exist: 'pages.studentDetail.lmsBlock.errors.doesNotExist',
};

/** customErrors → one toast text (known codes localized, others raw). */
export const lmsBlockErrorText = (
  errors: ErrList,
  t: TFn,
): string | undefined =>
  errors
    ?.map((e) => {
      const key = e?.code ? LMS_BLOCK_ERROR_KEYS[e.code] : undefined;
      return key ? t(key) : e?.message || e?.code || null;
    })
    .filter(Boolean)
    .join('\n') || undefined;
